// extracted by mini-css-extract-plugin
export default {"root":"_1_8nX","heading-and-subheading-block":"_3Xfv1","headingAndSubheadingBlock":"_3Xfv1","subheading":"_3jwtP"};